import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as NotaFiscalTypes,
  Creators as NotaFiscalActions,
} from '../ducks/NotaFiscal';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getNotas({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/invoices', {
      params: payload,
    });
    if (status === 200) {
      yield put(NotaFiscalActions.getNotasSuccess(data));
    } else {
      Sentry.captureMessage('getNotas failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(NotaFiscalActions.getNotasError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalActions.getNotasError());
  }
}

function* putNotas({ payload }) {
  const { id, data } = payload;
  try {
    const { status } = yield call(api.put, `/invoices/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (status === 200) {
      yield put(NotaFiscalActions.putNotasSuccess());
    } else {
      Sentry.captureMessage('putNotas failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(NotaFiscalActions.putNotasError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalActions.putNotasError());
  }
}

function* paidNotas({ payload }) {
  try {
    const { status } = yield call(api.post, `/invoices/${payload}/pay`);
    if (status === 200) {
      yield put(NotaFiscalActions.paidNFSuccess());
    } else {
      Sentry.captureMessage('paidNotas failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(NotaFiscalActions.paidNFError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalActions.paidNFError());
  }
}

function* getNotaById({ payload }) {
  const { id } = payload;
  try {
    const { status, data } = yield call(api.get, `/invoices/${id}`);
    if (status === 200) {
      yield put(NotaFiscalActions.getNotaByIdSuccess(data));
    } else {
      Sentry.captureMessage('getNotaById failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(NotaFiscalActions.getNotaByIdError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalActions.getNotaByIdError());
  }
}

function* receiptUpload({ payload }) {
  const { id, data } = payload;
  try {
    const { status } = yield call(api.post, `/invoices/${id}/receipt`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (status === 200) {
      yield put(NotaFiscalActions.receiptUploadSuccess());
    } else {
      Sentry.captureMessage('receiptUpload failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(NotaFiscalActions.receiptUploadError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalActions.receiptUploadError(error.response));
  }
}

function* getNotasWatcher() {
  yield takeLatest(NotaFiscalTypes.GET_NOTAS, getNotas);
}

function* putNotasWatcher() {
  yield takeLatest(NotaFiscalTypes.PUT_NOTAS, putNotas);
}

function* paidNotasWatcher() {
  yield takeLatest(NotaFiscalTypes.PAID_NOTAS, paidNotas);
}

function* getNotaByIdWatcher() {
  yield takeLatest(NotaFiscalTypes.GET_NOTA_BY_ID, getNotaById);
}

function* receiptUploadWatcher() {
  yield takeLatest(NotaFiscalTypes.RECEIPT_UPLOAD, receiptUpload);
}

export default function* rootSaga() {
  yield all([
    fork(getNotasWatcher),
    fork(putNotasWatcher),
    fork(paidNotasWatcher),
    fork(getNotaByIdWatcher),
    fork(receiptUploadWatcher),
  ]);
}
